import { useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'

import { DateRangePicker } from '../../../components/DatePicker/DateRangePicker'
import { DatePickerInputWithLabel } from '../../../components/DatePickerInputWithLabel'
import { DateObject } from '../../../helpers/date'
import { getTranslate, lang } from '../../../localization'

interface ContractDatePickerProps {
  onClose: () => void
  showDatePickerBox: boolean
  dateObject: DateObject
  setdateObject: (d: DateObject) => void
}
const ContractDatePicker: React.FC<ContractDatePickerProps> = ({
  onClose,
  showDatePickerBox,
  dateObject,
  setdateObject
}) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      {isSmall && (
        <DatePickerInputWithLabel
          label={getTranslate('Checkin-Checkout')}
          inputSize="small"
          placeholder={getTranslate('Enter a date Interval for reservation')}
          autoComplete="off"
          datePickerProps={{
            onChange: (newDate: DateObject) => setdateObject(newDate),
            dateObject
          }}
        />
      )}
      <DateRangePicker
        dateObject={dateObject}
        onChange={(d: DateObject) => setdateObject(d)}
        onClose={onClose}
        showDatePickerBox={showDatePickerBox}
        type={lang === 'fa' ? 'jalaali' : 'gregorian'}
      />
    </div>
  )
}

export default ContractDatePicker
